import React, { FC } from 'react'
import clsx from 'clsx'
import { makeStyles, Theme } from '@material-ui/core/styles'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import messages from '../../../messages'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: theme.spacing(160),
    padding: theme.spacing(5),
  },
  content: {
    paddingRight: theme.spacing(16),
    paddingBottom: theme.spacing(4),
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: theme.typography.fontWeightBold,
    textTransform: 'uppercase',
  },
  actions: {
    padding: theme.spacing(4, 6),
  },
  closeButton: {
    padding: 0,
  },
  borderRaduis: {
    '& .MuiPaper-rounded': {
      borderRadius: 0,
    },
  },
}))

interface TermsAndConditionsProps {
  product: string
  dialogOpen: boolean
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
  uploadDataType: string
  continueActionHandler: any
  data: any
  isProductChange: boolean
  onClose: any
}

const CautionPopUp: FC<TermsAndConditionsProps> = (props) => {
  const classes = useStyles()
  const {
    product,
    dialogOpen,
    setDialogOpen,
    uploadDataType,
    continueActionHandler,
    data,
    isProductChange,
    onClose,
  } = props

  const handleClose = () => {
    setDialogOpen(false)
    onClose()
  }

  const performSave = () => {
    setDialogOpen(false)
    continueActionHandler(product, data, uploadDataType, isProductChange)
  }

  return (
    <div className={classes.root}>
      <Dialog open={dialogOpen} maxWidth="md" className={classes.borderRaduis}>
        <DialogTitle>
          <div className={classes.title}>
            <FormattedMessage {...messages.CONF_CAUTION_HEADING} />
            <IconButton
              aria-label="close"
              onClick={handleClose}
              className={classes.closeButton}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent className={clsx(classes.content)}>
          <FormattedMessage {...messages.CONF_CAUTION_POPUP_TEXT_TUBES} />
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button
            onClick={performSave}
            color="primary"
            variant="contained"
            size="medium"
          >
            <FormattedMessage {...messages.CONTINUE} />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default CautionPopUp
